module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-12.8ace274e.jpg";